import React from 'react'
import { ArtworkItem, ArtworkContent } from '../../styles'
import ArtworkImage from './Image'
import OwnerInfo from '../../ownerPanel/OwnerInfo'
type Props = {
  collectionTitle: string
  collectionCount: number
  collectionUrl: string
  imageUrl: string
  thumbs: Array<string>
  index: string
  curatorUserId: number
  description: string
  avatarUrl: string
  curatorName: string
  jobTitle: string
}
export default (props: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const {
    imageUrl,
    collectionTitle,
    collectionCount,
    collectionUrl,
    thumbs,
    index,
    curatorUserId,
    description,
    avatarUrl,
    curatorName,
    jobTitle,
  } = props
  return (
    <ArtworkItem data-type='artworkItem' itemScope itemType='http://schema.org/CreativeWork'>
      <ArtworkContent itemScope itemType='http://schema.org/ImageObject'>
        <ArtworkImage
          imageUrl={imageUrl}
          collectionTitle={collectionTitle}
          collectionCount={collectionCount}
          collectionUrl={collectionUrl}
          thumbs={thumbs}
          index={index}
          description={description}
        />
        <OwnerInfo
          avatarUrl={avatarUrl}
          curatorName={curatorName}
          jobTitle={jobTitle}
          curatorUserId={curatorUserId}
        />
      </ArtworkContent>
    </ArtworkItem>
  )
}